import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Course } from '../../models/training/course.model';
import { ExchangeApiService } from '../exchange-api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CourseInstance } from '../../models/training/course-instance.model';
import * as moment from 'moment';

@Injectable()
export class CourseInstanceService {
  path = 'course_instances';

  constructor(
    private apiService: ExchangeApiService,
  ) {
  }

  get(id: string): Observable<CourseInstance> {
    return this.apiService.get(this.path + '/' + id)
      .pipe(map(data => new CourseInstance(data)));
  }

  getCatalogPaginatedInstances(course: Course, page: number): Observable<any> {
    const afterDate = moment().endOf('day').toISOString(false);

    const params: HttpParams = new HttpParams({
      fromObject: {
        closed: 'false',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'scheduleActions.startTime[strictly_after]': afterDate,
        billable: 'false',
        page: `${page}`,
        'course.id': course.id,
      },
    });

    return this.apiService.get(this.path, params);
  }
}
